import { useState } from "react";
import { getMeetingTemplateslot, getTemplateEmail, sendEmailBatchConfirmSlots, sendEmailInviteSlot } from "../services/email.service";

const INITIAL_SUCCESS_ERROR = {
  getAll: "",
  deleteMeetingById: "",
  cancelMeetingById: "",
  addMeeting: "",
  getById: "",
  sendEmailInviteSlot: "",
  getTemplateEmail: "",
  getTemplateslot: "",
};

export const useSendEmail = ({ spinner }) => {
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);
  const [invite, setInvite] = useState([])
  const [template, setTemplate] = useState([])

  const sendInviteSlot = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await sendEmailInviteSlot(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });

      return response;
    } else {
      setSuccess({ create: "create" });
      setInvite(response);
      return response;
    }
  };
  const getTemplate = async (templateType) => {
    clearAlerts();
    spinner(true);
    const response = await getTemplateEmail(templateType);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
      setTemplate(response);
      return response;
    }
  };

  const getTemplateslot = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await getMeetingTemplateslot(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
      setTemplate(response);
      return response;
    }
  };
  const sendBatchConfirmSlots = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await sendEmailBatchConfirmSlots(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
      return response;
    } else {
      setSuccess({ create: "create" });
      return response;
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };


  return {
    sendInviteSlot,
    sendBatchConfirmSlots,
    getTemplate,
    getTemplateslot,
    template,
    invite,
    success,
    error
  };
};
